export default function(id) {
    const nextInput = document.querySelector('#' + id);
    if(nextInput)
        nextInput.focus();
}
